import http from 'shared/utils/http';

export const getAssignment = (param) => {
  return http.get('/api/dray/assignment/', param);
};

export const createAssignment = (data) => {
  return http.post('/api/dray/assignment/', data);
};
